import React from 'react';
import App from './App.css';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routess } from './routess';
 

ReactDOM.render(

    <Routess />
,
  document.getElementById('root')
);
